import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { Close as CloseIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { usePostVastuHelp } from "../../hooks/query/useProperty";
import { toast } from "react-toastify";
interface DocumentUploadDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: FormData) => void;
  propertyId: string;
}
interface FormData {
  message: string;
  files: File[];
}
const DocumentUploadDialog: React.FC<DocumentUploadDialogProps> = ({
  open,
  onClose,
  propertyId,
}) => {
  const { handleSubmit, control, setValue, watch, reset } = useForm<FormData>({
    defaultValues: {
      message: "",
      files: [],
    },
  });
  const files = watch("files");
  // const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = event.target.files ? Array.from(event.target.files) : [];
  //   setValue("files", [...files, ...file], { shouldValidate: true });
  // };
  const handleDeleteFile = (fileIndex: number) => {
    setValue(
      "files",
      files.filter((_, index) => index !== fileIndex),
      { shouldValidate: true }
    );
  };
  const { mutate: postVastuHelp } = usePostVastuHelp();
  const submitHandler: SubmitHandler<FormData> = (data) => {
    // onSubmit(data);
    toast.promise(
      new Promise((resolve, reject) => {
        try {
          console.log("Data", data);
          onClose();
          postVastuHelp(
            { propertyId: propertyId, formData: data },
            {
              onSuccess: (response) => {
                reset();
                resolve(response);
              },
              onError: (error: any) => {
                const errorMessage =
                  error?.body?.error?.message ||
                  // error?.message ||
                  "An unknown error occurred.";
                console.log("Error mesage", errorMessage);
                reject(new Error(errorMessage));
              },
            }
          );
        } catch (error: any) {
          const errorMessage =
            error?.body?.error?.message ||
            // error?.message ||
            "An unknown error occurred.";
          console.log("Error mesage", errorMessage);
          reject(new Error(errorMessage));
        }
      }),
      {
        pending: "Sending message",
        success: "Message sent  successfully! :tada:",
        error: {
          render({ data }: { data: any }) {
            console.log("Data", data.body);
            // 'data' is the error object from the rejected promise
            return data?.message || "Failed to send message. Please try again.";
          },
        },
      }
    );
    // await postVastuHelp({
    //   propertyId: propertyId,
    //   formData: data,
    // });
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Upload files
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <>
          <Typography>Upload for Gridded Floor Plan</Typography>
          <Box component="form" onSubmit={handleSubmit(submitHandler)}>
            <Controller
              name="message"
              control={control}
              // rules={{ required: "Message is required" }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Message"
                  multiline
                  rows={4}
                  margin="normal"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
            {/* <Button variant="contained" component="label" sx={{ mb: 2 }}>
            Upload files
            <input
              type="file"
              hidden
              multiple
              accept="application/pdf,image/*"
              onChange={handleFileChange}
            />
          </Button> */}
            <Controller
              name="files"
              control={control}
              rules={{
                validate: (files) =>
                  files.length > 0
                    ? true
                    : "At least one document is required.",
              }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <Button variant="contained" component="label" sx={{ mb: 2 }}>
                    Upload Documents
                    <input
                      type="file"
                      hidden
                      multiple
                      accept="application/pdf,image/*"
                      onChange={(event) => {
                        const files = event.target.files
                          ? Array.from(event.target.files)
                          : [];
                        setValue("files", [...field.value, ...files], {
                          shouldValidate: true,
                        });
                      }}
                    />
                  </Button>
                  {error && (
                    <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                      {error.message}
                    </Typography>
                  )}
                </>
              )}
            />

            {files?.length > 0 && (
              <Box>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Uploaded files:
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                  }}
                >
                  {files.map((file, index) => (
                    <Box
                      key={index}
                      sx={{
                        position: "relative",
                        width: 120,
                        height: 120,
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        backgroundColor: "#F9F9F9",
                      }}
                    >
                      {/* Preview the file */}
                      {file.type.startsWith("image/") ? (
                        <img
                          src={URL.createObjectURL(file)}
                          alt={file.name}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                          }}
                        />
                      ) : (
                        <Typography
                          variant="body2"
                          sx={{ textAlign: "center", p: 1 }}
                        >
                          {file.name}
                        </Typography>
                      )}
                      {/* Delete button */}
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => handleDeleteFile(index)}
                        sx={{
                          position: "absolute",
                          top: 4,
                          right: 4,
                          backgroundColor: "rgba(255, 255, 255, 0.7)",
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </Box>
        </>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit(submitHandler)} variant="contained">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default DocumentUploadDialog;
